export type GuestLoginDeepLinkMode = 'login' | 'register'

/**
 * Banner / campaign URLs use `?guest=login` or `?guest=register`.
 * Anything else is ignored so random query noise cannot open the modal.
 */
export function parseGuestLoginQuery (guest: unknown): GuestLoginDeepLinkMode | null {
  const value = Array.isArray(guest) ? guest[0] : guest
  if (value === 'login' || value === 'register') {
    return value
  }
  return null
}

export function queryWithoutGuestParam<T extends Record<string, unknown>> (
  query: T
): { query: T, changed: boolean } {
  if (!Object.prototype.hasOwnProperty.call(query, 'guest')) {
    return { query, changed: false }
  }
  const next = { ...query }
  delete next.guest
  return { query: next, changed: true }
}
